export type PlanId = 'basic' | 'pro' | 'max' | 'trial';

export interface Entitlements {
	maxChildren: number;
	maxObservers: number;
	canAddEvents: boolean;
	/**
	 * Dla Basic: zamiast dni obowiązuje limit ostatnich wpisów (mini historia)
	 * Jeśli historyDays === 0 i set miniHistoryCount > 0, używamy mini historii.
	 */
	historyDays: number;
	miniHistoryCount?: number;
	/**
	 * Docelowa flaga sterująca reklamami; na razie nieużywana w UI.
	 */
	adsDisabled: boolean;
	reportsEnabled: boolean;
}

export const PLANS: Record<PlanId, Entitlements> = {
	basic: {
		maxChildren: 99,
		maxObservers: 0,
		canAddEvents: true,
		historyDays: 0,
		miniHistoryCount: 5,
		adsDisabled: false,
		reportsEnabled: false
	},
	pro: {
		maxChildren: 99,
		maxObservers: 3,
		canAddEvents: true,
		historyDays: 180,
		adsDisabled: true,
		reportsEnabled: true
	},
	max: {
		maxChildren: 99,
		maxObservers: 3,
		canAddEvents: true,
		historyDays: 180,
		adsDisabled: true,
		reportsEnabled: true
	},
	trial: {
		maxChildren: 99,
		maxObservers: 3,
		canAddEvents: true,
		historyDays: 180,
		adsDisabled: true,
		reportsEnabled: true
	}
};

export function isValidPlanId(planId: string): planId is PlanId {
	return planId === 'basic' || planId === 'pro' || planId === 'max' || planId === 'trial';
}


